import { render } from "./estrellas.vue?vue&type=template&id=474810e8&scoped=true"
import script from "./estrellas.vue?vue&type=script&lang=js"
export * from "./estrellas.vue?vue&type=script&lang=js"

import "./estrellas.vue?vue&type=style&index=0&id=474810e8&scoped=true&lang=css"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-474810e8"]])

export default __exports__